import { Dialog, DialogContent } from '@mui/material';
import React, { useContext } from 'react';
import { AccountSettings } from '@aws-amplify/ui-react';
import SnackbarContext from '../../context/snackbar-context';

const PasswordResetDialog = ({ username, open, onClose }) => {

  const snackbarContext = useContext(SnackbarContext);

  const handleSuccess = () => {
    // Close dialog and show success message
    snackbarContext.openSnackbarSuccess('Password reset successfully.');
    onClose();
  };

  const handleError = (error) => {
    snackbarContext.openSnackbarError(`Password reset failed: ${error.message}`);
  }

  return (
    <Dialog open={open} onClose={onClose} maxWidth="sm" fullWidth>
      <DialogContent>
        <AccountSettings.ChangePassword onSuccess={handleSuccess} onError={handleError} />
      </DialogContent>
    </Dialog>
  );
};

export default PasswordResetDialog;